import React, { useReducer } from 'react';
import { WarboxConversationContext } from './warboxConversationContext';
import warboxConversationReducer from './warboxConversationReducer';
import { DEFAULT_WARBOX_CONVERSATION_STATE } from './constants/defaultState';
import { clearState, setLoading } from '../utils';
import { IWarboxConversationState } from './types';
import {
    getConversation,
    getConversations,
    updateConversation,
    deleteConversation,
} from './utils';
import { UPSERT_WARBOX_CONVERSATION } from './constants/actions';

export const WarboxConversationState = ({
    children,
}: IWarboxConversationState) => {
    const [state, dispatch] = useReducer(
        warboxConversationReducer,
        DEFAULT_WARBOX_CONVERSATION_STATE
    );

    return (
        <WarboxConversationContext.Provider
            value={{
                ...state,
                clearState: () =>
                    clearState(dispatch, DEFAULT_WARBOX_CONVERSATION_STATE),
                setLoading: () => setLoading(dispatch),
                getConversation: (conversationId) =>
                    getConversation(dispatch, conversationId),
                getConversations: (filters, options) =>
                    getConversations(dispatch, filters, options),
                updateConversation: (body, conversationId, options) =>
                    updateConversation(dispatch, body, conversationId, options),
                deleteConversation: (conversationId) =>
                    deleteConversation(dispatch, conversationId),
                upsertConversation: (conversation) =>
                    dispatch({
                        type: UPSERT_WARBOX_CONVERSATION,
                        payload: conversation,
                    }),
            }}
        >
            {children}
        </WarboxConversationContext.Provider>
    );
};
